import axios from 'axios'
import CONFIG from '../config.js'

import takeFirstResult from '@/api/util/takeFirstResult'
import flattenACF from '@/api/util/flattenACF'
import normalizeWordpress from '@/api/util/normalizeWordpress'
import transformProject from '@/api/util/transformProject'
import transformFlexContent from '@/api/util/transformFlexContent'
import transformLocalizationInfo from '@/api/util/transformLocalizationInfo'
import transformPostMeta from '@/api/util/transformPostMeta'

export function getProjectsList ({ lang = 'de-ch', filter = 'all' }) {
	if (filter === 'all') {
		return axios.get(`${CONFIG.API_URL}/wp/v2/work?per_page=100${lang === 'en-us' ? '&lang=en' : '&lang=de'}`, {
			transformResponse: [].concat(
				axios.defaults.transformResponse,
				normalizeWordpress,
				flattenACF,
				transformLocalizationInfo,
				transformPostMeta,
				transformProject
			)
		}).then((response) => {
			// console.log(response.data)
			return response
		})
	}
}

export function getProjectBySlug ({ lang = 'de-ch', slug = '' }) {
	return new Promise((resolve, reject) => {
		axios.get(`${CONFIG.API_URL}/wp/v2/work?slug=${slug}${lang === 'en-us' ? '&lang=en' : '&lang=de'}`, {
			transformResponse: [].concat(
				axios.defaults.transformResponse,
				takeFirstResult,
				normalizeWordpress,
				flattenACF,
				transformProject,
				transformLocalizationInfo,
				transformPostMeta,
				transformFlexContent
			)
		})
		.then(response => {
			const { data } = response
			// console.log(response)
			;(data && data.id) ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' })
		})
		.catch(response => reject(response))
	})
}

export default 'yolo'



// WEBPACK FOOTER //
// ./src/api/projects.wp.api.js